module.exports = {
    "collectionLabel": `Sugestii`
};


//# sourceMappingURL=ro-RO.main.js.map
